import email from "../assets/email.webp";
import linkedin from "../assets/linkedin.webp";
import typescript from "../assets/typescript.webp";
import react from "../assets/react.webp";
import redux from "../assets/redux.webp";
import logo from "../assets/logo.webp";
import logoDarkMode from "../assets/logoDarkMode.webp";
import backgroundHeader from "../assets/backgroundHeader.webp";

export default {
  logoDarkMode,
  linkedin,
  backgroundHeader,
  typescript,
  react,
  redux,
  email,
  logo,
};
